var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('index',_vm._b({},'index',_vm.options,false))}
var staticRenderFns = []

export { render, staticRenderFns }